<template>
  <div>
    <el-card style="margin-top: 20px">
      <el-table
        :data="tableData"
        style="width: 100%"
        :header-cell-style="{ background: '#F2F5FF', color: '#333' }"
        height="450"
        border
      >
        <el-table-column label="序号" width="50">
          <template slot-scope="scope">
            {{ scope.$index + (PageIndex - 1) * PageSize + 1 }}
          </template>
        </el-table-column>
        <el-table-column prop="TypeName" label="分类名称"> </el-table-column>
        <el-table-column prop="BelongTypeName" label="归属"> </el-table-column>
        <el-table-column prop="BigTypeName" label="父级分类"> </el-table-column>
        <el-table-column label="创建时间" prop="CreateTime"> </el-table-column>
        <el-table-column label="排序" prop="OrderSort"> </el-table-column>
        <el-table-column label="状态" prop="StatusName"> </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="PageIndex"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="PageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        style="text-align: center;padding:20px; 0 0 0"
      >
      </el-pagination>
    </el-card>
  </div>
</template>
<script>
import { GetFoodTypeList } from "../../../api/api";
export default {
  data() {
    return {
      tableData: ["1"],
      PageSize: 10,
      PageIndex: 1,
      total: 0,
    };
  },
  created() {
    this.GetFoodTypeList();
  },
  methods: {
    async GetFoodTypeList() {
      const params = {
        PageSize: this.PageSize,
        PageIndex: this.PageIndex,
      };
      let res = await GetFoodTypeList(params);
      if (res.data.success) {
        this.tableData = res.data.response.data;
        this.total = res.data.response.dataCount;
      } else {
        this.tableData = [];
        this.total = 0;
      }
    },
    handleCurrentChange(val) {
      this.PageIndex = val;
      this.GetFoodTypeList();
    },
    handleSizeChange(val) {
      this.PageSize = val;
      this.GetFoodTypeList();
    },
  },
};
</script>
<style lang="less" scoped>
.el-button--goon {
  color: #fff;
  background-color: #5474e6;
  border-color: #5474e6;
  height: 34px;
  line-height: 34px;
  padding: 0 20px;
}
.mg-left {
  margin-left: 20px;
}
.mg-right {
  margin-right: 20px;
}
.tui-symbol {
  padding: 0 10px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
}
</style>